var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateBotton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8901 4.58C14.0201 4.32 13.0601 4.15 12.0001 4.15C7.21008 4.15 3.33008 8.03 3.33008 12.82C3.33008 17.62 7.21008 21.5 12.0001 21.5C16.7901 21.5 20.6701 17.62 20.6701 12.83C20.6701 11.05 20.1301 9.39 19.2101 8.01M13.2401 1.5L16.1301 4.82L12.7601 7.28",
    stroke: "#9499A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateBotton);
export default __webpack_public_path__ + "static/media/Rotate Botton.9bc6950e76dcb5e1d87e32cdb3b8c81f.svg";
export { ForwardRef as ReactComponent };